module.exports = __webpack_public_path__ + "static/media/2-5.26a0ab3a.mp3";